// extracted by mini-css-extract-plugin
export default {"form":"RegisterPage_form__Tscya","form-group":"RegisterPage_form-group__ku+9b","link":"RegisterPage_link__IzrvK"};